interface ArticleHeaderProps {
  eyebrow?: string;
  title: string;
  lede?: string;
  type?: string;
  readTime?: string;
  updated?: string;
  author?: string;
}

export function ArticleHeader({
  eyebrow,
  title,
  lede,
  type,
  readTime,
  updated,
  author,
}: ArticleHeaderProps) {
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((s) => s[0])
      .join("")
      .slice(0, 2);
  };

  return (
    <div className="mb-4 rounded-[10px] bg-white p-8">
      {eyebrow && <div className="detail__eyebrow">{eyebrow}</div>}
      <h1 className="detail__title mt-3" data-testid="wiki-page-title">
        {title}
      </h1>
      {lede && <p className="article__lede">{lede}</p>}
      <div className="article__meta">
        {type && <span className="chip">{type}</span>}
        {readTime && <span>{readTime}</span>}
        {(type || readTime) && updated && <span className="sep">·</span>}
        {updated && <span>Updated {updated}</span>}
        {author && (
          <>
            <span className="sep">·</span>
            <span className="author">
              <span className="ava">{getInitials(author)}</span>
              {author}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
